// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-viewer {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.json-tabs {
  display: flex;
  gap: 4px;
  padding: 8px 12px;
  border-bottom: 1px solid #334155;
  background-color: #0f172a;
}

.json-tab {
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #94a3b8;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.json-tab:hover {
  color: #cbd5e1;
  border-color: #475569;
}

.json-tab.active {
  background-color: #1e40af;
  border-color: #3b82f6;
  color: #f1f5f9;
}

.json-toolbar {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #334155;
  background-color: #0f172a;
}

.json-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 4px;
  color: #cbd5e1;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.json-button:hover {
  background-color: #334155;
  color: #f1f5f9;
  border-color: #475569;
}

.json-button.copy:hover {
  background-color: rgba(59, 130, 246, 0.15);
  border-color: #3b82f6;
  color: #3b82f6;
}

.json-button.download:hover {
  background-color: rgba(34, 197, 94, 0.15);
  border-color: #22c55e;
  color: #22c55e;
}

.json-content {
  flex: 1 1;
  overflow: auto;
  margin: 0;
  padding: 16px;
  background-color: #0f172a;
  color: #cbd5e1;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.json-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.json-content::-webkit-scrollbar-track {
  background-color: #0f172a;
}

.json-content::-webkit-scrollbar-thumb {
  background-color: #334155;
  border-radius: 4px;
}

.json-content::-webkit-scrollbar-thumb:hover {
  background-color: #475569;
}

.json-editor {
  flex: 1 1;
  overflow: auto;
  padding: 16px;
  background-color: #1e293b;
  color: #cbd5e1;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  border: 1px solid #334155;
  resize: none;
}

.json-editor:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.json-editor::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.json-editor::-webkit-scrollbar-track {
  background-color: #1e293b;
}

.json-editor::-webkit-scrollbar-thumb {
  background-color: #334155;
  border-radius: 4px;
}

.json-editor::-webkit-scrollbar-thumb:hover {
  background-color: #475569;
}

.json-error {
  padding: 12px 16px;
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #fca5a5;
  border-radius: 4px;
  margin: 12px 16px 0 16px;
  font-size: 13px;
}

.json-success {
  padding: 12px 16px;
  background-color: rgba(34, 197, 94, 0.1);
  border: 1px solid #22c55e;
  color: #86efac;
  border-radius: 4px;
  margin: 12px 16px 0 16px;
  font-size: 13px;
}

.json-button.edit:hover {
  background-color: rgba(251, 191, 36, 0.15);
  border-color: #fbbf24;
  color: #fbbf24;
}

.json-button.save:hover {
  background-color: rgba(34, 197, 94, 0.15);
  border-color: #22c55e;
  color: #22c55e;
}

.json-button.save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.json-button.cancel:hover {
  background-color: rgba(239, 68, 68, 0.15);
  border-color: #ef4444;
  color: #ef4444;
}

.json-tab:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.json-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/JsonViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".json-viewer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.json-tabs {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid #334155;\r\n  background-color: #0f172a;\r\n}\r\n\r\n.json-tab {\r\n  padding: 6px 12px;\r\n  background-color: transparent;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.json-tab:hover {\r\n  color: #cbd5e1;\r\n  border-color: #475569;\r\n}\r\n\r\n.json-tab.active {\r\n  background-color: #1e40af;\r\n  border-color: #3b82f6;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.json-toolbar {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #334155;\r\n  background-color: #0f172a;\r\n}\r\n\r\n.json-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.json-button:hover {\r\n  background-color: #334155;\r\n  color: #f1f5f9;\r\n  border-color: #475569;\r\n}\r\n\r\n.json-button.copy:hover {\r\n  background-color: rgba(59, 130, 246, 0.15);\r\n  border-color: #3b82f6;\r\n  color: #3b82f6;\r\n}\r\n\r\n.json-button.download:hover {\r\n  background-color: rgba(34, 197, 94, 0.15);\r\n  border-color: #22c55e;\r\n  color: #22c55e;\r\n}\r\n\r\n.json-content {\r\n  flex: 1;\r\n  overflow: auto;\r\n  margin: 0;\r\n  padding: 16px;\r\n  background-color: #0f172a;\r\n  color: #cbd5e1;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.json-content::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.json-content::-webkit-scrollbar-track {\r\n  background-color: #0f172a;\r\n}\r\n\r\n.json-content::-webkit-scrollbar-thumb {\r\n  background-color: #334155;\r\n  border-radius: 4px;\r\n}\r\n\r\n.json-content::-webkit-scrollbar-thumb:hover {\r\n  background-color: #475569;\r\n}\r\n\r\n.json-editor {\r\n  flex: 1;\r\n  overflow: auto;\r\n  padding: 16px;\r\n  background-color: #1e293b;\r\n  color: #cbd5e1;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  border: 1px solid #334155;\r\n  resize: none;\r\n}\r\n\r\n.json-editor:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.json-editor::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.json-editor::-webkit-scrollbar-track {\r\n  background-color: #1e293b;\r\n}\r\n\r\n.json-editor::-webkit-scrollbar-thumb {\r\n  background-color: #334155;\r\n  border-radius: 4px;\r\n}\r\n\r\n.json-editor::-webkit-scrollbar-thumb:hover {\r\n  background-color: #475569;\r\n}\r\n\r\n.json-error {\r\n  padding: 12px 16px;\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n  border: 1px solid #ef4444;\r\n  color: #fca5a5;\r\n  border-radius: 4px;\r\n  margin: 12px 16px 0 16px;\r\n  font-size: 13px;\r\n}\r\n\r\n.json-success {\r\n  padding: 12px 16px;\r\n  background-color: rgba(34, 197, 94, 0.1);\r\n  border: 1px solid #22c55e;\r\n  color: #86efac;\r\n  border-radius: 4px;\r\n  margin: 12px 16px 0 16px;\r\n  font-size: 13px;\r\n}\r\n\r\n.json-button.edit:hover {\r\n  background-color: rgba(251, 191, 36, 0.15);\r\n  border-color: #fbbf24;\r\n  color: #fbbf24;\r\n}\r\n\r\n.json-button.save:hover {\r\n  background-color: rgba(34, 197, 94, 0.15);\r\n  border-color: #22c55e;\r\n  color: #22c55e;\r\n}\r\n\r\n.json-button.save:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.json-button.cancel:hover {\r\n  background-color: rgba(239, 68, 68, 0.15);\r\n  border-color: #ef4444;\r\n  color: #ef4444;\r\n}\r\n\r\n.json-tab:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.json-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
